import React from 'react';
import { connect } from 'react-redux';
import template from '../../../../templates/Stones/AssignPricing/PricingPresets/index.rt';
import * as actions from '../../../../actions';
import * as pricingPresetPages from '../../../../constants/pricingPresets';
import {AccessRights} from '../../../../schemas/accessRightsModel';

function mapStateToProps(state, props) {
  let page = state.pricingPreset.page || pricingPresetPages.PRICING_PRESET_LIST;
  let title = "Algorithm Presets";
  switch(state.pricingPreset.page) {
    case pricingPresetPages.PRICING_PRESET_EDIT:
      title = "Algorithm Designer";
      break;
    case pricingPresetPages.PRICING_PRESET_NEW:
      title = "New Algorithm Preset";
      break;
  }
  return {
    presets: state.pricingPreset.presets,
    page,
    title,
    AR: AccessRights.get(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setPreset: (preset) => dispatch(actions.pricingPresets.setSelected(preset)).catch(console.error),
    toPage: (page) => dispatch(actions.pricingPresets.changePage(page)).catch(console.error)
  };
}

const connector = connect(mapStateToProps, mapDispatchToProps);

class pricingPresets extends React.Component {
  render = template
  constructor(props) {
    super(props);
    this.state = {
      page: this.props.page
    }
  }

  /**
   * Change Manage Pricing Preset Page
   * @param {constants pricingPresets.PRICING_PRESET_(NEW/LIST/EDIT)} page
   * @param {object} preset
   */
  toPage = (page, preset) => {
    if(preset) {
      this.props.setPreset(preset);
    }
    this.setState({page: page}, () => this.props.toPage(page));
  }
}

const PricingPresets = connector(pricingPresets);

export { PricingPresets };
